import moment from 'moment'
import React, { useEffect, useState } from 'react'
import { useHistory, useLocation } from 'react-router-dom'
import { StepathonApi } from '../../../services'
import { Breadcrumb, Heading, Input, RadioGroup } from '../../common/atoms'
import { successOrFailureToaster } from '../../common/atoms/messages'
import { DatePicker } from '../../tailwind/molecules'
import CreateOrUpdateModelStepathon from '../../modals/CreateOrUpdateModelStepathon'
import CreateOrUpdateTeamModel from '../../modals/CreateOrUpdateTeamModel'
import { SALES_ROLE } from '../../../constants/overview'
import { calculateMilestoneSteps, calculateNoOfDays } from './StepathonBussinessLogic'
import { dsButtonPrimary, dsButtonSecondary, joinButtonClasses } from '../../../utils/buttonStyles'
 
const CreateStepathonPage = () => {
  const location = useLocation()
  const [state, setState] = useState({
    formValues: {
      name : '',
      start_date : '',
      end_date : '',
      max_user_steps_per_day : 25000,
      stepathon_type : location.state?.disabled.includes('individual') ? location.state?.disabled.includes('team') ? 'Milestone' : 'Team' : 'Individual',
      stepathon_mode : 'Company-wide stepathon',
      target_milestone_steps: 0
    },
    openModal : false,
    teamModal : false,
    errors : {}
  })

  useEffect(() => {
    if(state.formValues.stepathon_type === 'Milestone') {
      if(state.formValues.start_date && state.formValues.end_date && state.formValues.max_user_steps_per_day) {
        const target_milestone_steps = calculateMilestoneSteps(state.formValues.max_user_steps_per_day, calculateNoOfDays(state.formValues.start_date, state.formValues.end_date), location.state?.total_employee_count)
        setSubState({ formValues: { ...state.formValues, target_milestone_steps } })
      }
    }
  }, [state.formValues.start_date, state.formValues.end_date, state.formValues.stepathon_type, state.formValues.max_user_steps_per_day])

  const history = useHistory()

  const setSubState = (newState) => {
    setState(prevState => { return {...prevState, ...newState } })
  }
 
 const navigateToCreateStepathon =() =>{
    if (validateStepathon(state.formValues)) {
      const value = state.teamModal
      formValues.stepathon_type === 'Milestone' ? setSubState({openModal: true}) : setSubState({teamModal :  !value})
    }
  }

  const openTeamModelCreateStepathon = () => {
      const value = state.openModal
      const teamVal = state.teamModal
      setSubState({openModal :  !value, teamModal: !teamVal})
  }

  const changeHandler = (name, value) =>{
    setSubState({ formValues: { ...state.formValues, [name]: value }, errors : {} })
  }
 
 const validateStepathon = (formValues) =>{
   let newError = {}
   if (!formValues.name) {
     newError = {...newError, name : 'Name of the stepathon is mandatory'}
   }
   else if (!formValues.max_user_steps_per_day) {
     newError = {...newError, max_user_steps_per_day : 'Enter the steps limit per day per person'}
   }
   else if (formValues.max_user_steps_per_day > 25000) {
    newError = {...newError, max_user_steps_per_day : '25000 steps maximum limit per day for an individual'}
   }
   else if (!formValues.start_date) {
     newError = {...newError, start_date : 'Please enter date in correct format'}
   }
   else if (isNotValid(moment().format('DD-MM-YYYY'),formValues.start_date, 1)) {
     newError = {...newError, start_date : 'Date can not be less than or equal to the current date'}
   }
   else if (!formValues.end_date) {
     newError = {...newError, end_date : 'Please enter date in correct format'}
   }
   else if (isNotValid(formValues.start_date,formValues.end_date)) {
     newError = {...newError, end_date : 'Date can not be less than the start date'}
   }
   else if (formValues.stepathon_type == 'Milestone' && formValues.target_milestone_steps < 1) {
    newError = {...newError, target_milestone_steps : 'Target milestone steps should be greater than 0'}
   }
  setSubState({errors : newError})
   return Object.keys(newError || {}).length === 0
 }
  const isNotValid = (startDate, endDate, value = 0)=>{
   if(!startDate || !endDate) return false
   const diffDays = moment(endDate, 'DD-MM-YYYY').diff(moment(startDate, 'DD-MM-YYYY'), 'days')
   if(diffDays < value) return true
   return false
 }
const CreateStepathon = (e, data) =>{ 
  let stepathon_mode = data[0].stepathon_type?.toLowerCase() === 'milestone' ? 'company_wide' : data[0]?.stepathon_mode === 'Company-wide stepathon' ? 'company_wide' : 'closed'
  let payloadData = {
    stepathon:{
      start_date : `${data[0].start_date}`,
      end_date : `${data[0].end_date}`,
      name : `${data[0].name}`,
      max_user_steps_per_day : `${data[0].max_user_steps_per_day}`,
      stepathon_type : `${data[0].stepathon_type?.toLowerCase()}`,
      stepathon_mode : `${stepathon_mode}`,
    }
  }
  if(data[0].stepathon_type?.toLowerCase() === 'milestone') {
    payloadData.stepathon.target_milestone_steps = data[0].target_milestone_steps
  }
  StepathonApi.createStepathon(
    {data: payloadData},
    (resp) => {
      const data = resp.data
      setSubState({ formValues: {...data } })
      successOrFailureToaster({ message:  'Stepathon is succesfully created' })
      sessionStorage.removeItem('empDataImport')
      history.push({pathname: '/stepathon', state : data.serializer})
    },
    (_) => {
      setSubState({openModal : false})
      successOrFailureToaster({ message:  'There is already Stepathon scheduled in this time frame!' , type : 'fail'})
      scrollToMiddle()
    }
  )
}

const scrollToMiddle = () => {
  setTimeout(function() {
    window.scrollTo(
      {
        top: 0,
        left: 0,
        behavior: 'smooth'
      }
    ), 100
  })
}

  const saveRadioBtn = (e) => {
    let {name,value} = e.target
    setSubState({ formValues: {...state.formValues, [name]: value}})
  }
 
 const {formValues} = state 
 return (
   <React.Fragment>
      <Breadcrumb
       list={[
         { text: 'Engagement', link: '/stepathon' },
         { text: 'Stepathon', link: '/stepathon' },
         { text: 'Create stepathon', link: '#' }
       ]}
       classes='mb-1'
     />
    <Heading
      mainHeading='Create stepathon'
      subHeading='An activity to boost up for your employees health and fitness'
      subClasses='mt-2 text-ts-sm leading-relaxed text-gray-600'
    />
    <div className='mt-6'>
      <div className='bg-white p-ds-6 rounded-t-ds-lg border border-b-0 border-gray-300'>
        <div className='w-1/2'>
         <Input
           label='NAME OF THE STEPATHON' 
           name= 'name'
           labelClasses='text-ts-xs font-semibold tracking-[0.1em] text-gray-500 mb-3'
           inputClasses='text-base font-semibold  text-gray-700 leading-4'
           value={formValues.name}
           error={state.errors.name}
           onChange = {(e) => {
             let {name , value} = e.target
             var letters = /^[a-zA-Z\s]*$/;
             if(!value.match(letters)) return false
             value = (value === ' ' ? value.trim() : value )
             changeHandler(name, value)
            }}
         />
         </div>
         <div className='mt-6 flex flex-col'>
          <RadioGroup
              radioList={['Individual', 'Team', 'Milestone']}
              radioInputClasses = 'h-6 w-6 focus:ring-0'
              value={formValues.stepathon_type}
              disabled={location.state?.disabled.length > 0}
              disableClass={['', 'font-proxima-nova text-gray-300 text-base font-semibold ml-4']}
              name = 'stepathon_type'
              tooltipText={['An individual stepathon has already been created, you can create another stepathon only once that stepathon has concluded', 'A Team stepathon has already been created, you can create another stepathon only once that stepathon has concluded', 'A Milestone stepathon has already been created, you can create another stepathon only once that stepathon has concluded']}
              error = {state.errors.stepathon_type}
              handler={(e) => {
                let {name,value} = e.target
                changeHandler(name, value)
              }} 
              radioClasses='flex flex-col mt-3 '
              labelClases='text-base text-gray-700 font-semibold ml-4 leading-5 font-proxima-nova'
              subTitle={['Lets your employee participate individually in the Stepathon','Lets your employee create teams and participate with their teams in the Steapthon', 'Let your employees to participate and achieve the step milestone set by the organization.']} 
              subTitleClasses='ml-10 mb-6 font-proxima-nova'
              title='STEPATHON FOR'
              disableItem={location.state?.disabled}
              titleClasses='text-ts-xs font-semibold tracking-[0.1em] text-gray-500'
            />
          </div>
        <div>

        </div>
        <div className='w-1/2'>
          <Input
            label='STEPS LIMIT'
            subLabel='25000 steps maximum limit per day for an individual'
            subLabelClasses='text-ts-sm text-gray-500 mb-3'
            name= 'max_user_steps_per_day'
            labelClasses='text-ts-xs font-semibold tracking-[0.1em] text-gray-500 mb-3'
            inputClasses='text-base font-semibold  text-gray-700 leading-4'
            value={formValues.max_user_steps_per_day}
            error={state.errors.max_user_steps_per_day}
            onChange = {(e) =>
              {
                let {name , value} = e.target
                var numbers = /^[0-9]*$/;
                if(!value.match(numbers)) return false
                changeHandler(name, value)
              }
            }
          />
        </div>
        <div className='mt-6 w-1/2'>
           <DatePicker
             labelClasses='font-semibold tracking-widest leading-3 mb-3 mt-6'
             label='START DATE'
             value = {formValues.start_date}
             inputClasses='text-gray-700 bg-gray-100 font-semibold text-base leading-4 w-full h-14'
             classes ='mt-5'
             color='#6B7280'
             size='12px'
             error={state.errors.start_date}
             handler={(value) => {
               let name='start_date'
               changeHandler(name, value)
             }} 
           />
           <DatePicker
             labelClasses='font-semibold tracking-widest leading-3 mb-3 mt-6'
             label='END DATE'
             value = {formValues.end_date}
             inputClasses='text-gray-700 bg-gray-100 font-semibold text-base leading-4 w-full h-14'
             classes ='mt-5'
             color='#6B7280'
             size='12px'
             error={state.errors.end_date}
             handler={(value) => {
               let name='end_date'
               changeHandler(name, value)
             }} 
           />
           {state.formValues.stepathon_type == 'Milestone' && <div className='mt-6'>
              {state.formValues.stepathon_type == 'Milestone' && <div className='w-full mt-3'>
                <Input
                  subLabel='Steps count for the milestone'
                  subLabelClasses='text-ts-sm text-gray-500 mb-3'
                  name= 'target_milestone_steps'
                  inputClasses='text-base font-semibold text-gray-700 leading-4 w-full'
                  value={formValues.target_milestone_steps}
                  error={state.errors.target_milestone_steps}
                  onChange = {(e) =>
                    {
                      let {name , value} = e.target
                      var numbers = /^[0-9]*$/;
                      if(!value.match(numbers)) return false
                      changeHandler(name, value)
                    }
                  }
                />
                <p className='text-ts-sm text-gray-500 mt-2'>Above recommendations are based on total employee registered on the platform</p>
              </div>}
           </div>}
         </div>
      </div>
      <div className='flex flex-row justify-end px-ds-7 py-ds-4 rounded-b-ds-lg border border-gray-300 bg-ds-brand-lt'>
         <button
           className={joinButtonClasses(dsButtonSecondary, 'mr-4 h-11 px-6')}
           onClick={() => history.goBack('/stepathon') }
         >
           Cancel
         </button>
         <button
          type='submit'
          onClick={navigateToCreateStepathon}
          disabled={SALES_ROLE === "sales"}
          className={joinButtonClasses(dsButtonPrimary, 'h-11 px-6', SALES_ROLE === 'sales' && 'cursor-not-allowed')}
        >
          Create stepathon
        </button>
      </div>
    </div>
    { state.openModal &&
      <CreateOrUpdateModelStepathon
        visible={state.openModal}
        onCancel={()=> setSubState({openModal: false})}
        subTitle='Do you want to create stepathon? You can disable the stepathon before the start time if you change your mind.'
        data={[state.formValues]}
        handler={CreateStepathon}
      />
    }
    { (state.teamModal && formValues.stepathon_type !== 'Milestone') &&
      <CreateOrUpdateTeamModel
        radioName='stepathon_mode'
        radioBtnValue={state.formValues.stepathon_mode}
        visible={state.teamModal}
        onCancel={()=> setSubState({teamModal: false})}
        data={[state.formValues]}
        radioList={['Company-wide stepathon', 'Closed stepathon']}
        subTitle={
          state.formValues?.stepathon_type === 'Individual' ?
          [
            'Every employee is involved in the Individual Stepathon on the ekincare app, giving them the freedom to track their own steps and set personal goals. This boosts engagement and provides flexibility.',
            'You can upload the members list as a CSV or XLSX file for the stepathon, as only the uploaded members will be eligible to participate.'
          ] :
          [
            'Give your employees the freedom to create their own teams for this stepathon on the ekincare app. This gives them more flexibility and increases overall engagement during the stepathon',
            'You can upload the teams list as a CSV or XLSX file directly from here for this stepathon. These teams will be reflected on the ekincare app when the stepathon starts'
          ]
        }
        handler={openTeamModelCreateStepathon}
        formHandler={saveRadioBtn}
      />
    }
   </React.Fragment>
 )
}
 
export default CreateStepathonPage
